import { render } from "./MSidebar.vue?vue&type=template&id=3e2d41a4&scoped=true"
import script from "./MSidebar.vue?vue&type=script&lang=js"
export * from "./MSidebar.vue?vue&type=script&lang=js"

import "./MSidebar.vue?vue&type=style&index=0&id=3e2d41a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2d41a4"]])

export default __exports__